import { render, staticRenderFns } from "./change_city.vue?vue&type=template&id=6fa158d8&scoped=true&"
import script from "./change_city.vue?vue&type=script&lang=js&"
export * from "./change_city.vue?vue&type=script&lang=js&"
import style0 from "./change_city.vue?vue&type=style&index=0&id=6fa158d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa158d8",
  null
  
)

export default component.exports